import { Controller } from 'stimulus'

export default class BuyNow extends Controller {
  static targets = [
    'stripe',
    'button',
    'overlay',
    'payment',
    'card',
    'errors'
  ]

  async initialize () {
    const {
      product,
      publishableKey,
      sku
    } = JSON.parse(this.stripeTarget.innerText)

    this.sku = sku
    this.product = product
    this.publishableKey = publishableKey

    const stripe = Stripe(this.publishableKey)
    const elements = stripe.elements()
    const paymentRequest = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: this.product.name,
        amount: this.sku.price
      }
    })

    const prButton = elements.create('paymentRequestButton', {
      paymentRequest
    })

    // const style = {
    //   base: {
    //     color: '#32325d',
    //     lineHeight: '18px',
    //     fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    //     fontSmoothing: 'antialiased',
    //     fontSize: '16px',
    //     '::placeholder': {
    //       color: '#aab7c4'
    //     }
    //   },
    //   invalid: {
    //     color: '#fa755a',
    //     iconColor: '#fa755a'
    //   }
    // }

    // const card = elements.create('card', { style })
    // card.mount(this.cardTarget)
    //
    // console.log(card)

    if (await paymentRequest.canMakePayment()) {
      prButton.mount(this.buttonTarget)
    } else {
      console.debug('Your environment does nto support payments')
    }
  }

  stopClosePropagation (e) {
    e.stopPropagation()
  }

  openOverlay (e) {
    console.log(e)
    this.overlayTarget.classList.add('open')
  }

  closeOverlay () {
    this.overlayTarget.classList.remove('open')
  }
}
